import { render } from "./AwardGroup.vue?vue&type=template&id=01c6a972"
import script from "./AwardGroup.vue?vue&type=script&lang=js"
export * from "./AwardGroup.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__